import { Component } from '@angular/core';

@Component({
  selector: 'app-not-supported',
  templateUrl: './not-supported.component.html'
})

export class NotSupportedComponent {}
